import React from "react";
import naqvi from "../images/naqvi1.jpg";
import teacher1 from "../images/teacher2.jpeg";
import abidi from "../images/abidi.jpeg";
import farhat from "../images/farhat.jpeg";
import asghar from "../images/asghar.jpeg";
import nabi from "../images/nabi.jpeg";
import "./teacher.css";

function Teachers() {
  return (
    <>
      <section className="trainer">
        <h1 className="heading">
          <span>expert teachers</span>
        </h1>
        <div className="box-container">
          <div className="box">
            <img src={naqvi} alt="" />
            <div className="info">
              <h3>Dr.Syed Sajjad Naqvi</h3>
              <span>PHD in tafseer-e-quran</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={teacher1} alt="" />
            <div className="info">
              <h3>Dr.Yousaf jamali</h3>
              <span>pHD in Firqaha-e-maasir Kalami</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={abidi} alt="" />
            <div className="info">
              <h3>Molana Hassan abidi</h3>
              <span>pHD in History of Eh-lul-bait</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={asghar} alt="" />
            <div className="info">
              <h3>molana Asghar Ali Laskani</h3>
              <span>pHD in Current affairs</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={farhat} alt="" />
            <div className="info">
              <h3>Dr.Farhat Abbas Hiadri</h3>
              <span>PhD in Allome & funoon Qirrat</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>

          <div className="box">
          <img src={nabi} alt="" />
            <div className="info">
              <h3>Qari Ghulam Nabi Sadiqi</h3>
              <span>MPhil Quran & Allome Qirrat</span>
              <div className="share">
                <a
                  href="https://www.facebook.com/SajjadNaqv"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-facebook-f"
                >
                  {" "}
                </a>
                <a
                  href="https://wa.me/989388030994/?text=I%20need%20some%20information%20can%20i%20?"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-whatsapp"
                >
                  {" "}
                </a>
                <a
                  href="tel:+989388030994"
                  target="_blank"
                  rel="noreferrer"
                  className="fas fa-phone"
                >
                  {" "}
                </a>
                <a
                  href="https://www.youtube.com/channel/UCmvODTtMxqu0--sBAZispHg"
                  target="_blank"
                  rel="noreferrer"
                  className="fab fa-youtube"
                >
                  {" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Teachers;
